import styled from 'styled-components';

import { HR } from '@zillow/zrs-comet';

export const StyledAnchor = styled.a`
    display: block;
    position: relative;
    top: -55px;
    visibility: hidden;
`;

export const StyledHR = styled(HR)`
    opacity: 0.4;
    flex-basis: initial;
    ${props => props.theme.ns().spacing.getSpacingMixin()};
`;
